import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        screenWidth:document.documentElement.clientWidth, //屏幕宽度
        solutionBlockKey:''
    },
    mutations: {
        changeSolutionBlockKey(state,val){
            console.log('key',val)
            state.solutionBlockKey = val
        }
    },
    actions: {
        changeSolutionBlockKey({ commit },info){
            commit('changeSolutionBlockKey',info);
        },
    },
    modules: {
    }
})
